import React from 'react'
import axios from 'axios'
import ErrorSwal from '../components/SwalError'
import { Button } from 'reactstrap'
import { FaRegSave } from "react-icons/fa";
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { FaWrench } from "react-icons/fa";
import { UserProfile } from '../components/functions/LoginPage';
import { If, Then, Else } from 'react-if'
import { useDispatch } from 'react-redux'
import { updateProfile } from '../components/redux/actions/authAction'

const Settings = () => {

    //call redux action
    const dispatch = useDispatch();

    const { t } = useTranslation()
    const history = useHistory()
    const cancelToken = React.useRef(null)
    const [render1, setRender1] = React.useState(false)
    const [render2, setRender2] = React.useState(false)
    const [render3, setRender3] = React.useState(false)
    const [render4, setRender4] = React.useState(false)
    const [render5, setRender5] = React.useState(false)

    const [error, setError] = React.useState(null)
    const [users, setUsers] = React.useState([])
    const [values, setValues] = React.useState({
        EmpNo: '',
        FullName: '',
        NickName: '',
        Email: '',
        Mobile: '',
        Password: '',
    })


    const getData = async () => {
        try {

            const Token = JSON.parse(localStorage.getItem("token")).access_token
            const response = await UserProfile(Token)

            setUsers(response.data.employee)
            setValues({
                ...values,
                EmpNo: response.data.employee.EMP_NO,
                FullName: response.data.employee.FULL_NAME,
                NickName: response.data.employee.NICKNAME,
                Email: response.data.employee.E_MAIL,
                Mobile: response.data.employee.MOBILE,
                Password: ''
            })

            if (users.FIRST_LOGIN === '1') {
                setRender5(!render5)
            }

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }

    React.useEffect(() => {

        cancelToken.current = axios.CancelToken.source()
        getData()

        return () => {
            cancelToken.current.cancel()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleChange = (e) => {
        setValues({
            ...values,
            [e.target.name]: e.target.name === 'Mobile' ? e.target.value.replace(/\D/g, '') : e.target.value,
        })
    }

    const handleSubmitFullName = async (e) => {
        e.preventDefault()
        if (values.FullName === '') {
            ErrorSwal({ title: 'error', text: 'Full Name is required.', icon: 'error' })
        }
        else {
            await axios({
                method: 'patch',
                url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
                headers: { "Access-Control-Allow-Origin": "*", "Content-type": "Application/json" },
                data: { values: values, at: 'FullName', val: values.FullName }
            }).then((response) => {
                ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                setRender1(!render1)
                history.go(0)
            }).catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        }

    }
    const handleSubmitNickName = async (e) => {
        e.preventDefault()
        if (values.NickName === '') {
            ErrorSwal({ title: 'error', text: 'Nick Name is required.', icon: 'error' })
        }
        else {
            await axios({
                method: 'patch',
                url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
                headers: { "Access-Control-Allow-Origin": "*", "Content-type": "Application/json" },
                data: { values: values, at: 'NICKNAME', val: values.NickName }
            }).then((response) => {
                ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                setRender2(!render2)
                history.go(0)
            }).catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        }

    }
    const handleSubmitEMail = async (e) => {
        e.preventDefault()
        if (values.Email === '') {
            ErrorSwal({ title: 'error', text: 'E-MAIL is required.', icon: 'error' })
        }
        else {
            await axios({
                method: 'patch',
                url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
                headers: { "Access-Control-Allow-Origin": "*", "Content-type": "Application/json" },
                data: { values: values, at: 'EMail', val: values.Email }
            }).then((response) => {
                ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                setRender3(!render3)
                history.go(0)
            }).catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        }

    }
    const handleSubmitMobile = async (e) => {
        e.preventDefault()
        if (values.Mobile === '') {
            ErrorSwal({ title: 'error', text: 'Mobile is required.', icon: 'error' })
        }
        else if (values.Mobile.length < 10) {
            ErrorSwal({
                title: 'error',
                text: 'The minimum entered is 10.',
                icon: 'error'
            })
        }
        else {
            await axios({
                method: 'patch',
                url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
                headers: { "Access-Control-Allow-Origin": "*", "Content-type": "Application/json" },
                data: { values: values, at: 'Mobile', val: values.Mobile }
            }).then((response) => {
                ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                setRender4(!render4)
                history.go(0)
            }).catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        }

    }
    const handleSubmitPasswowrd = async (e) => {
        e.preventDefault()

        if (values.Password.length < 6) {
            ErrorSwal({
                title: 'error',
                text: 'The minimum entered is 6 or more.',
                icon: 'error'
            })
        }
        else {
            // console.log(e,values.Password);
            // console.log(11111);
            await axios({
                method: 'patch',
                url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
                headers: { "Access-Control-Allow-Origin": "*", "Content-type": "Application/json" },
                data: { values: values, at: 'Password', val: values.Password }
            }).then((response) => {
                ErrorSwal({ title: 'Success', text: response.data.message, icon: 'success' })
                if (response.data.Status_login === 0) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('profile')
                    dispatch(updateProfile(null))
                }
                setRender5(!render5)
                history.go(0)

            }).catch(error => {
                if (error?.response?.data) {
                    const { data } = error.response
                    setError(data.message)
                }
            })
        }


    }
    // const handleClickSubmit = async (e) => {
    // e.preventDefault()
    // console.log(e)
    // console.log(values)
    // if (values.Password) {
    //     if (values.Password.length < 6) {
    //         ErrorSwal({
    //             title: 'error',
    //             text: 'The minimum entered is 6 or more.',
    //             icon: 'error'
    //         })
    //     }
    // }

    // await axios({
    //     method: 'patch',
    //     url: process.env.REACT_APP_LOGIN_URL + values.EmpNo,
    //     headers: {
    //         "Access-Control-Allow-Origin": "*",
    //         "Content-type": "Application/json"
    //     },
    //     data: values,
    // })
    //     .then((response) => {
    //         ErrorSwal({
    //             title: 'Success',
    //             text: response.data.message,
    //             icon: 'success'
    //         })

    //         if (response.data.Status_login === 0) {
    //             localStorage.removeItem('token')
    //             localStorage.removeItem('profile')
    //         }
    //         history.replace("/Dashboard");

    //     })
    //     .catch(error => {
    //         if (error?.response?.data) {
    //             const { data } = error.response
    //             setError(data.message)
    //         }
    //     })

    // }
    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title"> {t('t_header_setting')} </h4>
                            </div>
                            <div className="card-content">
                                <div className="card-body">
                                    {/* <form className="row g-3" onSubmit={handleClickSubmit}> */}
                                    <div className="row g-3" >
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label className="col-sm-4 col-md-4"> {t('t_company')} : </label>
                                                <div className="col-sm-8 col-md-8 text-bold-500 font-blue-dark"> {users.COMPANY} </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label className="col-sm-4 col-md-4"> {t('t_empNo')} : </label>
                                                <div className="col-sm-8 col-md-8 text-bold-500 font-blue-dark"> {users.EMP_NO} </div>
                                            </div>
                                        </div>

                                        <div className="mt-3 row">
                                            <If condition={render1}>
                                                <Then>
                                                    <label className="col-sm-4 col-md-2"> {t('t_full_name')} :</label>
                                                    <div className="mb-2 col-sm-5 col-md-6">
                                                        <input className='form-control form-control-sm' type="text" placeholder="Enter your Full Name" name="FullName" value={values.FullName} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-sm-3 col-md-4 text-end ">
                                                        <Button color="primary" className="btn-sm" onClick={handleSubmitFullName}>  <FaRegSave />  </Button>
                                                        {' '}
                                                        <Button color="danger" className="btn-sm" onClick={async () => setRender1(!render1)}>  X  </Button>
                                                    </div>
                                                </Then>
                                                <Else>
                                                    <label className="col-sm-4 col-md-2"> {t('t_full_name')} : </label>
                                                    <div className="col-sm-6 col-md-6 text-bold-500 font-blue-dark"> {users.FULL_NAME} </div>
                                                    <div className="col-sm-2 col-md-4 text-end">
                                                        <Button color="success" className="btn-sm" onClick={async () => setRender1(!render1)} >  <FaWrench />  </Button>
                                                    </div>
                                                </Else>
                                            </If>
                                        </div>
                                        <div className="mt-3 row">
                                            <If condition={render2}>
                                                <Then>
                                                    <label className="col-sm-4 col-md-2 "> {t('t_nick_Name')} :</label>
                                                    <div className="mb-2 col-sm-5 col-md-6">
                                                        <input className='form-control form-control-sm' type="text" placeholder="Enter your NickName" name="NickName" value={values.NickName} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-sm-3 col-md-4 text-end ">
                                                        <Button color="primary" className="btn-sm" onClick={handleSubmitNickName}>  <FaRegSave />  </Button>
                                                        {' '}
                                                        <Button color="danger" className="btn-sm" onClick={async () => setRender2(!render2)}>  X  </Button>
                                                    </div>
                                                </Then>
                                                <Else>
                                                    <label className="col-sm-4 col-md-2"> {t('t_nick_Name')} : </label>
                                                    <div className="col-sm-6 col-md-6 text-bold-500 font-blue-dark"> {users.NICKNAME} </div>
                                                    <div className="col-sm-2 col-md-4 text-end">
                                                        <Button color="success" className="btn-sm" onClick={async () => setRender2(!render2)} >  <FaWrench />  </Button>
                                                    </div>
                                                </Else>
                                            </If>
                                        </div>
                                        <div className="mt-3 row">
                                            <If condition={render3}>
                                                <Then>
                                                    <label className="col-sm-4 col-md-2"> {t('t_email')} :</label>
                                                    <div className="mb-2 col-sm-5 col-md-6">
                                                        <input className='form-control form-control-sm' type="text" placeholder="Enter your Email" name="Email" value={values.Email} onChange={handleChange} />
                                                    </div>
                                                    <div className="col-sm-3 col-md-4 text-end ">
                                                        <Button color="primary" className="btn-sm" onClick={handleSubmitEMail}>  <FaRegSave />  </Button>
                                                        {' '}
                                                        <Button color="danger" className="btn-sm" onClick={async () => setRender3(!render3)}>  X  </Button>
                                                    </div>
                                                </Then>
                                                <Else>
                                                    <label className="col-sm-4 col-md-2"> {t('t_email')} : </label>
                                                    <div className="col-sm-6 col-md-6 text-bold-500 font-blue-dark"> {values.Email} </div>
                                                    <div className="col-sm-2 col-md-4 text-end">
                                                        <Button color="success" className="btn-sm" onClick={async () => setRender3(!render3)} >  <FaWrench />  </Button>
                                                    </div>
                                                </Else>
                                            </If>
                                        </div>
                                        <div className="mt-3 row">
                                            <If condition={render4}>
                                                <Then>
                                                    <label className="col-sm-4 col-md-2 "> {t('t_mobile')} :</label>
                                                    <div className="mb-2 col-sm-5 col-md-6">
                                                        <input className='form-control form-control-sm' type="text" placeholder="Enter your phone number" name="Mobile" value={values.Mobile} onChange={handleChange} maxLength={10} />
                                                    </div>
                                                    <div className="col-sm-3 col-md-4 text-end ">
                                                        <Button color="primary" className="btn-sm" onClick={handleSubmitMobile}>  <FaRegSave />  </Button>
                                                        {' '}
                                                        <Button color="danger" className="btn-sm" onClick={async () => setRender4(!render4)}>  X  </Button>
                                                    </div>
                                                </Then>
                                                <Else>
                                                    <label className="col-sm-4 col-md-2"> {t('t_mobile')} : </label>
                                                    <div className="col-sm-6 col-md-6 text-bold-500 font-blue-dark"> {values.Mobile} </div>
                                                    <div className="col-sm-2 col-md-4 text-end">
                                                        <Button color="success" className="btn-sm" onClick={async () => setRender4(!render4)} >  <FaWrench />  </Button>
                                                    </div>
                                                </Else>
                                            </If>
                                        </div>
                                        <div className="mt-3 row">
                                            <If condition={render5}>
                                                <Then>
                                                    <label className="col-sm-4 col-md-2 "> {t('t_password')} :</label>
                                                    <div className="mb-2 col-sm-5 col-md-6">
                                                        <input className='form-control form-control-sm' type="password" placeholder="Enter your Password" name="Password" onChange={handleChange} />
                                                    </div>
                                                    <div className="col-sm-3 col-md-4 text-end ">
                                                        <Button color="primary" className="btn-sm" onClick={handleSubmitPasswowrd}>  <FaRegSave />  </Button>
                                                        {' '}
                                                        <Button color="danger" className="btn-sm" onClick={async () => setRender5(!render5)}>  X  </Button>
                                                    </div>
                                                </Then>
                                                <Else>
                                                    <label className="col-sm-4 col-md-2"> {t('t_password')} : </label>
                                                    <div className="col-sm-6 col-md-6 text-bold-500 font-blue-dark"> ***************** </div>
                                                    <div className="col-sm-2 col-md-4 text-end">
                                                        <Button color="success" className="btn-sm" onClick={async () => setRender5(!render5)} >  <FaWrench />  </Button>
                                                    </div>
                                                </Else>
                                            </If>
                                        </div>
                                        {/* <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label for="" className="col-sm-4 col-form-label col-form-label-sm"> {t('t_email')} :</label>
                                                <div className="col-sm-8">
                                                    <input className='form-control' type="text" name="Email" value={values.Email} onChange={handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label for="" className="col-sm-4 col-form-label col-form-label-sm">
                                                    <span style={{ color: 'red' }}> {t('t_password')}  * </span> :
                                                </label>
                                                <div className="col-sm-8">
                                                    <input className='form-control' type="password" name="Password" onChange={handleChange} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <label for="" className="col-sm-4 col-form-label col-form-label-sm"> {t('t_mobile')} :</label>
                                                <div className="col-sm-8">
                                                    <input className='form-control' type="text" name="Mobile" value={values.Mobile} onChange={handleChange} />
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* <div className="gap-2 mt-3 d-grid d-md-flex justify-content-md-end">
                                            <Button className="ml-2" color="primary">
                                                <FaRegSave /> {t('b_submit')}
                                            </Button>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default Settings